<template>
  <div class="login-box">
    <div class="login-logo">
      <router-link to="/"><b>Admin</b> Agar Balkan</router-link>
    </div>
    <!-- /.login-logo -->
    <div class="login-box-body">
      <p class="login-box-msg">Sign in to start your session</p>
      <form @submit.prevent="Login">

        <div v-if="error" class="alert alert-danger">
          <a class="close" data-dismiss="alert">&times;</a>
          {{ error }}
        </div>

        <div class="form-group has-feedback">
          <input type="text" class="form-control" placeholder="Username" v-model="credentials.email">
          <span class="glyphicon glyphicon-user form-control-feedback"></span>
        </div>
        <div class="form-group has-feedback">
          <input type="password" class="form-control" placeholder="Password" v-model="credentials.password">
          <span class="glyphicon glyphicon-lock form-control-feedback"></span>
        </div>
        <div class="row">
          <div class="col-xs-8">
            <div class="checkbox icheck">
            <label>
            <div class="icheckbox_square-blue" aria-checked="false" aria-disabled="false" style="position: relative;"><input type="checkbox" style="position: absolute; top: -20%; left: -20%; display: block; width: 140%; height: 140%; margin: 0px; padding: 0px; border: 0px; opacity: 0; background: rgb(255, 255, 255);"><ins class="iCheck-helper" style="position: absolute; top: -20%; left: -20%; display: block; width: 140%; height: 140%; margin: 0px; padding: 0px; border: 0px; opacity: 0; background: rgb(255, 255, 255);"></ins></div> Remember Me
            </label>
            </div>
          </div>
          <!-- /.col -->
          <div class="col-xs-4">
            <button type="submit" class="btn btn-primary btn-block btn-flat">Sign In</button>
          </div>
          <!-- /.col -->
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Login',
    data: function () {
      return {
        form: new Form({}),
        credentials: {
          email: '',
          password: ''
        },
        error: ''
      }
    },
    methods: {
      Login: function () {
        $('#loading-login').show()
        var self = this
        var data = this.credentials
        if (data.email !== '' && data.password !== '') {
          this.form.post(baseUrl + 'Home/Login', data).then(function (result) {
            $('#loading-login').hide()
            // Success
            self.loginProcess(result)
          }, function (reason) {
            // rejection
          })
        } else {
          this.wrongCredentials = true
          $('#loading-login').hide()
        }
      },
      loginProcess: function (result) {
        // Success
        if (result.status === 1) {
          // Code for localStorage/sessionStorage.
          if (result.role >= 5) {
            localStorage.setItem('user_id', result.user_id)
            localStorage.setItem('role', result.role)
            localStorage.setItem('token_log', result.token_log)
            localStorage.setItem('token_header', result.token_header)
            sessionStorage.removeItem('logout')
            // Whole login proccess
            // this.$store.commit("LOGIN", { arg: true });
            this.$store.commit('SET_TOKEN_LOG', result.token_log)
            this.$store.commit('SET_TOKEN_HEADER', result.token_header)
            this.$store.commit('SET_NAME', result.nickname)
            localStorage.setItem('nickname', result.nickname)
            this.$store.commit('SET_ROLE', result.role)
            this.$router.push('/dashboard')
          } else {
            this.error = 'You are not an admin'
          }
        }

        // Must send some field
        if (result.status === 0) {
          this.error = 'Some field is not sent'
        }
        if (result.status === 2) {
          this.error = 'Wrong credentials'
        }
      }
    },
    mounted: function () {
      require('icheck')

      $('input').iCheck({
        checkboxClass: 'icheckbox_square-blue',
        radioClass: 'iradio_square-blue',
        increaseArea: '20%' // optional
      })
    }
  }
</script>



// WEBPACK FOOTER //
// Login.vue?71bb1694